function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import Dropdown from "../elements/dropdown";
import Icon from "../elements/icon";
import WindowUtils from "../../mixins/window-overflow-mixin";
import AdvancedComboboxContent from "./advanced-combobox-content";
import KeyPressManager from "../../utils/keypress-manager";
import { prevFocusWithWrap, nextFocusWithWrap } from "../../utils/accessibility-utils";
var array = PropTypes.array,
    object = PropTypes.object,
    string = PropTypes.string,
    any = PropTypes.any,
    func = PropTypes.func,
    bool = PropTypes.bool,
    oneOfType = PropTypes.oneOfType; // Expects the follow formats:
// For Groups: {label: "Group Label", items: [...]}
// For Items: {label: "Option Label", value: "Option value", icon: "icon-class", disabled: true}

var AdvancedCombobox = /*#__PURE__*/function (_React$Component) {
  _inherits(AdvancedCombobox, _React$Component);

  var _super = _createSuper(AdvancedCombobox);

  function AdvancedCombobox() {
    var _this;

    _classCallCheck(this, AdvancedCombobox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      height: undefined,
      open: false
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      _this.setState({
        height: undefined,
        open: false,
        reverse_open: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
      _this.setState({
        open: true
      });

      if (typeof _this.props.onOpen === "function") {
        _this.props.onOpen();
      }

      return _.defer(function () {
        if (_this.mounted) {
          if (_this.state.open) {
            var ref = _this.advanced_combobox_content;
            var node = ReactDOM.findDOMNode(ref);
            var height = WindowUtils.calcHeight(node, {
              min: 175
            });

            var content_height = height - __guard__(WindowUtils.getDOMProperties(ReactDOM.findDOMNode(_assertThisInitialized(_this))), function (x) {
              return x.height;
            });

            _this.setState({
              height: content_height,
              reverse_open: height === 175
            });
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      if (_this.state.open) {
        if (typeof _this.props.onSearch === "function") {
          _this.props.onSearch();
        }

        if (typeof _this.props.onClose === "function") {
          _this.props.onClose();
        }

        _this.reset();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleComplete", function () {
      _this.handleClose();
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionLabel", function (value) {
      var option = _.findWhere(_this.props.options, {
        value: value
      });

      return (option != null ? option.label : undefined) || (option != null ? option.value : undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectionText", function () {
      var selection = _this.props.value;

      var display_text = function () {
        if (_.isArray(selection)) {
          // multi-select
          var num = _.size(selection);

          if (num > 1) {
            return "".concat(num, " Selected");
          } else if (num === 1) {
            return selection[0].label || _this.getOptionLabel(selection[0].value);
          }
        } else if (selection && Object.prototype.hasOwnProperty.call(selection, "value")) {
          // single select, and exists
          return selection.label || _this.getOptionLabel(selection.value);
        }
      }();

      return display_text || _this.props.placeholder;
    });

    return _this;
  }

  _createClass(AdvancedCombobox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          header = _this$props.header,
          formatSelection = _this$props.formatSelection;
      var open = this.state.open;
      header = header || formatSelection(this.getSelectionText(), value, placeholder, open);
      return /*#__PURE__*/React.createElement(KeyPressManager, {
        component: "span",
        onEnter: function onEnter() {
          return !_this2.props.disabled ? _this2.setState({
            open: !_this2.state.open
          }) : null;
        },
        onArrowDown: function onArrowDown(node, event) {
          return nextFocusWithWrap(node);
        },
        onArrowUp: function onArrowUp(node, event) {
          return prevFocusWithWrap(node);
        }
      }, /*#__PURE__*/React.createElement(Dropdown, {
        className: classNames(this.props.className, "et--advanced-combobox", {
          "is-opened-up": this.props.position === "up" || this.state.reverse_open,
          "et--advanced-combobox--compact": this.props.compact,
          "has-value": !_.isEmpty(this.props.value)
        }),
        bodyClasses: "et--advanced-combobox--content-wrapper",
        label: this.props.label,
        header: header,
        disabled: this.props.disabled,
        isOpen: this.state.open,
        onOpen: this.handleOpen,
        onClose: this.handleClose
      }, /*#__PURE__*/React.createElement(AdvancedComboboxContent, {
        ref: function ref(e) {
          _this2.advanced_combobox_content = e;
        },
        options: this.props.options,
        value: this.props.value,
        onChange: this.props.onChange,
        multiple: this.props.multiple,
        grouped: this.props.grouped,
        allowChangeAll: this.props.allowChangeAll,
        allowUnselectAll: this.props.allowUnselectAll,
        searchable: this.props.searchable,
        search_placeholder: this.props.search_placeholder,
        initial_search: this.props.initial_search,
        onSearch: this.props.onSearch,
        focusOnMount: true,
        onClose: this.props.onClose,
        createFromSearch: this.props.createFromSearch,
        formatItem: this.props.formatItem,
        formatSelection: this.props.formatSelection,
        placeholder: this.props.placeholder,
        empty_placeholder: this.props.empty_placeholder,
        loading: this.props.loading,
        isOpenedUp: this.state.reverse_open || this.props.position === "up",
        height: this.state.height,
        onComplete: this.handleComplete
      }), // Allow for additional content form children
      this.props.children ? /*#__PURE__*/React.createElement("div", {
        className: "et--advanced-combobox--extra"
      }, this.props.children) : undefined));
    }
  }]);

  return AdvancedCombobox;
}(React.Component);

_defineProperty(AdvancedCombobox, "displayName", "AdvancedCombobox");

_defineProperty(AdvancedCombobox, "propTypes", {
  options: oneOfType([array, object]),
  name: string,
  value: any,
  onChange: func,
  label: string,
  compact: bool,
  position: string,
  multiple: bool,
  grouped: bool,
  allowChangeAll: bool,
  allowUnselectAll: bool,
  searchable: bool,
  search_placeholder: string,
  initial_search: string,
  onSearch: func,
  // args: (new_search_string) # called when user types
  onOpen: func,
  // no args
  onClose: func,
  // no args
  createFromSearch: func,
  //
  formatItem: func,
  // args: (item, isSelected, isHovered, search_query, props)
  formatSelection: func,
  // args: (selectionText, selection, placeholder, open)
  placeholder: string,
  empty_placeholder: any,
  loading: bool,
  disabled: bool,
  closeOnEnter: bool
});

_defineProperty(AdvancedCombobox, "defaultProps", {
  placeholder: "Select Option...",
  formatSelection: function formatSelection(selectionText, selection, placeholder, open) {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: "et--advanced-combobox--selected-text"
    }, selectionText || placeholder), open ? /*#__PURE__*/React.createElement(Icon, {
      icon: "chevron-up"
    }) : /*#__PURE__*/React.createElement(Icon, {
      icon: "chevron-down"
    }));
  }
});

export { AdvancedCombobox as default };

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}